<template>
  <div>
    <title-row
      :title="page.title"
      :subtitle="page.subtitle"
      :breadcrumb-items="[
        page.breadcrumbItem,
      ]">
      <template #buttons>
        <title-row-button v-if="hasRight('DEVICE_WRITE')" :to="{ name: 'NewBarrier' }">
          <v-icon left>mdi-plus</v-icon>
          Új sorompó
        </title-row-button>
      </template>
    </title-row>

    <v-expansion-panels class="mb-4 rounded-xl overflow-hidden" :mandatory="!!Object.values(search).find((e) => e !== '')" flat>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="font-weight-medium">
            <v-icon left>mdi-magnify</v-icon>
            Keresés
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-2">
            <v-col :cols="12" :sm="6" :md="3">
              <v-text-field
                v-model="search.name"
                @input="searchEventHandler"
                label="Megnevezés"
                clearable
                hide-details
                filled
              />
            </v-col>
            <v-col :cols="12" :sm="6" :md="3">
              <v-autocomplete
                label="Kontroller"
                :items="controllers"
                item-text="name"
                item-value="element_id"
                @change="searchEventHandler"
                v-model="search.controller_id"
                hide-details
                clearable
                :value-comparator="$config.comparators.isEqual"
                filled
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card class="rounded-xl" flat>
      <v-data-table
        :loading="loading"
        :headers="dataTable.headers"
        :items="dataTable.items"
        :server-items-length="dataTable.itemsLength"
        :options.sync="dataTable.options"
        :footer-props="$config.dataTableFooterProps"
        calculate-widths
      >
        <template #[`item.k`]="{ item }">{{ item.x_coord }}, {{ item.y_coord }}</template>
        <template #[`item.actions`]="{ item }" class="d-flex justify-content-end" text-end>
          <v-btn
            v-if="hasRight('DEVICE_WRITE')"
            fab
            small
            color="primary"
            dark
            text
            class="rounded-sm"
            :to="{ name: 'BarrierEditor', params: { id: item.element_id } }"
            title="Módosítás"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-if="hasRight('DEVICE_WRITE')"
            fab
            small
            color="primary"
            dark
            text
            class="rounded-sm"
            @click="deleteBarrier(item)"
            title="Törlés"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { dataTablePage } from '@/mixins';

export default {
  mixins: [dataTablePage],

  data() {
    return {
      routeName: 'BarrierList',
      fetchItems: this.fetchBarrier,
      dataTable: {
        options: {
          sortBy: ['barrier_name'],
        },
        headers: [
          { text: 'Megnevezés', value: 'barrier_name' },
          { text: 'Controller', value: 'controller_name' },
          { text: 'Koordináta', value: 'k', sortable: false },
          { text: '', value: 'actions', sortable: false, align: 'end' },
        ],
      },
      search: {
        name: '',
        controller_id: 0,
      },
      controllers: [],
    };
  },

  mounted() {
    this.fetchControllers();
  },

  methods: {
    parseSearchQueries() {
      return {
        name: this.$route.query.name,
        controller_id: Number(this.$route.query.controller_id),
      };
    },

    async deleteBarrier(item) {
      const confirm = await this.$dialog.confirm({
        type: 'error',
        text: `<b>${item.name}</b> sorompó törlésére készül!<br>Folytatja?`,
        title: 'Figyelem',
      });

      if (!confirm) return;

      try {
        const response = await this.$http.post(`barriers/delete/${item.element_id}`);
        this.fetchItems();
        if (response.status === 'OK') {
          this.$dialog.notify.info('A sorompó törölve');
        }
      } catch (e) {
        console.error(e);
      }
    },

    async fetchControllers() {
      try {
        const response = await this.$http.post('controllers/list');
        this.controllers = response.controllers;
      } catch (e) {
        console.error(e);
      }
    },

    async fetchBarrier() {
      this.loading = true;
      try {
        const response = await this.$http.post('barriers/list', this.options);
        this.dataTable.items = response.barriers;
        this.dataTable.itemsLength = response.barriers_count;
        this.dataTable.options.page = this.$route.query.page * 1 || 1;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    searchQueries() {
      return {
        name: this.search.name || '',
        controller_id: Number(this.search.controller_id) || 0,
      };
    },
    page() {
      return {
        title: 'Sorompók',
        subtitle: this.dataTable.itemsLength === -1 ? 'Betöltés...' : `${this.dataTable.itemsLength} sorompó van a rendszerben`,
        breadcrumbItem: {
          text: 'Sorompók',
          disabled: true,
        },
      };
    },
  },
};
</script>
